module.exports = __webpack_public_path__ + "static/img/product_3_3.0e1f690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_3_3.png
// module id = JwkP
// module chunks = 34